<template>
  <div class="report-path">
    <Card style="padding-bottom: 40px">
      <Button @click="addReportPath" type="primary">添加</Button>
      <Table
          :loading="WarningLoading"
          :columns="columns"
          :data="data"
          :border="true"
          :highlight-current-row="true"
          style="margin-top: 10px"
      >
        <template #action="{ row, index }">
          <el-button size="small" type="text" @click="getReportPathById(row)">编辑</el-button>
          <el-button size="small" type="text" @click="deleteReportPath(row)">删除</el-button>
        </template>
      </Table>
    </Card>
    <Modal v-model="reportPathModal"
           :title="isEdit ? '修改' : '添加'"
    >
      <Form :model="reportPathFrom" :rules="reportPathRules" :label-width="100" ref="reportPathFrom">
        <FormItem label="上报途径" prop="name">
          <Input v-model="reportPathFrom.name"></Input>
        </FormItem>
      </Form>
      <template slot="footer">
        <Button @click="reportPathModal = false">取消</Button>
        <Button v-if="!isEdit" type="primary" :loading="addLoading" @click="addPath">确定</Button>
        <Button v-else type="primary" :loading="addLoading" @click="editPath">修改</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "reportPath",
  data() {
    return {
      reportPathModal: false,
      WarningLoading: false,
      addLoading: false,
      isEdit: false,
      columns: [
        {
          title: 'id',
          key: 'id',
          align: 'center',
        },
        {
          title: '上报途径',
          key: 'name',
          align: 'center',
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
        }
      ],
      data: [],
      reportPathFrom: {
        name: '',
      },
      reportPathRules: {
        name: [
          { required: true, message: '请输入上报途径', trigger: 'blur' }
        ],
      },
    }
  },
  mounted() {
    this.getWarningType()
  },
  methods: {
    addPath() {
      this.$refs.reportPathFrom.validate((valid) => {
        if (valid) {
          this.addLoading = true
          this.$http.post('/api/eventReportingChannelss', this.reportPathFrom).then(res => {
            this.addLoading = false
            this.reportPathModal = false
            this.$Message.success('添加成功')
            this.getWarningType()
          })
        } else {
          return false
        }
      })
    },
    getReportPathById(row) {
      let id = row.id
      this.$http.get(`/api/eventReportingChannelss/${ id }`).then(res => {
        if (res.status === 200) {
          this.isEdit = true
          this.reportPathFrom = res.data
          this.reportPathModal = true
        } else {
          this.$Message.error('获取数据失败')
        }
      })
    },
    editPath() {
      this.$refs.reportPathFrom.validate((valid) => {
        if (valid) {
          this.addLoading = true
          let request = {
            ...this.reportPathFrom
          }
          this.$http.put(`/api/eventReportingChannelss`, request).then(res => {
            if (res.status === 200) {
              this.addLoading = false
              this.reportPathModal = false
              this.$Message.success('修改成功')
              this.getWarningType()
            } else {
              this.$Message.error('修改失败')
            }
          })
        } else {
          return false
        }
      })
    },
    addReportPath() {
      this.reportPathModal = true
      this.isEdit = false
      this.reportPathFrom = {}
    },
    getWarningType() {
      this.$http.get('/api/eventReportingChannelss').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.data = res.data.data
        }
      })
    },
    deleteReportPath(row){
      this.$http.delete(`/api/eventReportingChannelss/${row.id}`).then(res => {
        console.log(res)
        this.getWarningType()
      })
    }
  }
}
</script>

<style scoped>

</style>
